import { useSiteConfig } from "@/hooks/useSiteConfig";
import strLogo from "@/assets/str-logo.png";

const LogoText = ({ className = "h-12", useFooterLogo = false }: { className?: string; useFooterLogo?: boolean }) => {
  const { getConfig } = useSiteConfig();
  
  const logoConfig = getConfig(useFooterLogo ? 'footer_logo' : 'header_logo');
  const logoUrl = logoConfig?.url || strLogo;
  const logoAlt = logoConfig?.alt || 'Servicio Turistico Rachel';

  return (
    <div className={`${className} flex items-center`}>
      <img 
        src={logoUrl} 
        alt={logoAlt}
        className={`${className} transition-transform duration-300 hover:scale-105`}
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};

export default LogoText;
